const originURL = new URL(window.location).origin;
const STORES_API_ENDPOINT = `${originURL}/basket/closest-stores?latitude=$1&longitude=$2`;

const getStores = (lat, lng) =>
    fetch(STORES_API_ENDPOINT.replace('$1', lat).replace('$2', lng))
        .then(res => res.json());

export default getStores;
